import request from '@/utils/request'

export function getMemberTag(query) {
    console.log("getMemberTag",typeof(query))
    // console.log("get_question", query)
    if(typeof(query)=="number"){
        return request({
            url: '/api/member/' + query,
            method: 'get',
        })
    }
    else{
        return request({
            url: '/api/member/' + query,
            method: 'get',
        })
    }
}
export function insert_update_member_tag(data) {
  // console.log(data);
    return request({
        url: '/api/member_tag',
        method: 'post',
        data
    })
}